var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgListIconGrey(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5868_9783)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.1403 18.6328H12.3691C11.614 18.6328 11.002 19.2449 11.002 20C11.002 20.7551 11.614 21.3672 12.3691 21.3672H36.1403C36.8954 21.3672 37.5075 20.7551 37.5075 20C37.5075 19.2449 36.8954 18.6328 36.1403 18.6328Z",
    fill: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1403 8.37891H12.3691C11.614 8.37891 11.002 8.991 11.002 9.74609C11.002 10.5012 11.614 11.1133 12.3691 11.1133H36.1403C36.8954 11.1133 37.5075 10.5012 37.5075 9.74609C37.5075 8.991 36.8954 8.37891 36.1403 8.37891Z",
    fill: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.1403 28.8867H12.3691C11.614 28.8867 11.002 29.4988 11.002 30.2539C11.002 31.009 11.614 31.6211 12.3691 31.6211H36.1403C36.8954 31.6211 37.5075 31.009 37.5075 30.2539C37.5075 29.4988 36.8954 28.8867 36.1403 28.8867Z",
    fill: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.3457 11.5918C5.36506 11.5918 6.19141 10.7654 6.19141 9.74609C6.19141 8.72674 5.36506 7.90039 4.3457 7.90039C3.32635 7.90039 2.5 8.72674 2.5 9.74609C2.5 10.7654 3.32635 11.5918 4.3457 11.5918Z",
    fill: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.3457 21.8457C5.36506 21.8457 6.19141 21.0194 6.19141 20C6.19141 18.9806 5.36506 18.1543 4.3457 18.1543C3.32635 18.1543 2.5 18.9806 2.5 20C2.5 21.0194 3.32635 21.8457 4.3457 21.8457Z",
    fill: "#A9A9A9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.3457 32.0996C5.36506 32.0996 6.19141 31.2733 6.19141 30.2539C6.19141 29.2346 5.36506 28.4082 4.3457 28.4082C3.32635 28.4082 2.5 29.2346 2.5 30.2539C2.5 31.2733 3.32635 32.0996 4.3457 32.0996Z",
    fill: "#A9A9A9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5868_9783"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 35,
    height: 35,
    fill: "white",
    transform: "translate(2.5 2.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgListIconGrey);
export default __webpack_public_path__ + "static/media/list_icon_grey.ba4534139db78b5488423ef405175788.svg";
export { ForwardRef as ReactComponent };